/*
* 阔地教育科技有限公司版权所有（codyy.com/codyy.cn）.
* Copyright (c) 2019, Codyy and/or its affiliates. All rights reserved.
* @Date: 2020.03.02 12:30.
* @Author
* @Description  项目 接口请求函数
**/

import request from '@/utils/request'

/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 banner数据 - 查询方法.
 **/

export function listData (params) {
  return request({
    // url: 'http://10.5.52.11:8088/schedule/res/resCacheHomePageList',
    url: 'http://chaoyangtask1.needu.cn/schedule/res/resCacheHomePageList',
    method: 'get',
    params
  })
}

/**
 *@Description
 *@Param url: 接口地址、params：请求参数、method：请求方式
 *@Return 项目 主体区域 数据 - 查询方法.
 **/

export function detailsData (params) {
  return request({
    // url: 'http://10.5.52.11:8088/schedule/res/resCacheDetailList',
    url: 'http://chaoyangtask1.needu.cn/schedule/res/resCacheDetailList',
    method: 'get',
    params
  })
}

